import axios from "../libs/axios";
// import qs from "qs";
import authHeader from "./auth-header";

const END_POINT = `${process.env.VUE_APP_API_ENDPOINT}`;

class OrderService {
  async list(query) {
    console.log("+++ Order.list");
    console.log(query);
    const result = await axios.get(END_POINT + `/v1/orders`, {
      params: query,
      headers: authHeader(),
    });
    return result;
  }

  async find(query) {
    console.log("+++ find");
    console.log(query);
    const result = await axios.post(END_POINT + `/v1/orders`, query, {
      headers: authHeader(),
    });
    return result;
  }

  async get(id) {
    const result = await axios.get(END_POINT + `/v1/order/${id}`, {
      headers: authHeader(),
    });
    return result;
  }

  async edit(data) {
    const result = await axios.post(
      END_POINT + `/v1/order/${data._id || ""}`,
      data,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  async editByDirectroy(directory, data) {
    const result = await axios.post(
      END_POINT + `/v1/orderbydirectory/${directory}`,
      data,
      {
        headers: authHeader(),
      },
    );
    return result;
  }

  download(mansion) {
    return axios.get(
      `${process.env.VUE_APP_API_ENDPOINT}/v1/download/order/${mansion}`,
      {
        responseType: "blob",
        dataType: "binary",
        headers: authHeader(),
      },
    );
  }
}

export default new OrderService();
